import { useFeatureContext } from "@omni/ui/components/Product/Feature/KeyFeatures/components/feature/context/feature.context";
import { cn } from "@omni/utils/styles";

type Props = {
    className?: string;
};

export const Name = ({ className }: Props) => {
    const { feature } = useFeatureContext();

    return (
        <span className={cn(className)}>
            <i
                className={cn("las la-lg la-check", "tw:text-primary tw:mr-2")}
            />
            {feature.name}
        </span>
    );
};
